export default __webpack_public_path__ + "static/media/logo.43016302.png";